export default __webpack_public_path__ + "static/New-c2dbd984915705e2c9194a2ca0103573.png";